import './Polyfill';
import {
	MOBILE_WIDTH,
	DPR,
	RENDER_OPTIONS,
	ASPECT_RATIO,
	ASSETS,
	NO_ALIAS,
	MOBILE_DEVICE,
} from './Constants';
import { formatValue, getWidth, getHeight, isGPUBlacklisted } from './Utils';
import {
	resize,
	handleDropdown,
	handleMapEvent,
	displayTooltip,
	countryInfo,
	handleMapClick,
	handleYear,
	handleTrend,
} from './Handlers';
import Model from './Model';
import LayoutManager from './Layouts';
import renderMap from './RenderMap';
import change from './Controller';
import ticker from './Ticker';
import template from './Template';
import * as PIXI from 'pixi.js'; // use pixi@4.8.8
import * as d3 from 'd3';
import _ from 'underscore';
import './style.scss';

PIXI.settings.PREFER_ENV = PIXI.ENV.WEBGL;

class Restrictions {
	constructor() {
		this.data_asset = `https://assets.pewresearch.org/interactives/religion/2025/restrictions-corrected/data.json`;
		this.selector = '#js-restrictions-corrected';
		this.renderMap = renderMap.bind(this);
		this.change = change.bind(this);
		this.ticker = ticker.bind(this);
		this.template = template.bind(this);
		this.resize = resize.bind(this);
		this.countryInfo = countryInfo.bind(this);
		this.handleDropdown = handleDropdown.bind(this);
		this.handleYear = handleYear.bind(this);
		this.handleTrend = handleTrend.bind(this);
		this.handleMapEvent = handleMapEvent.bind(this);
		this.displayTooltip = displayTooltip.bind(this);
		this.handleMapClick = handleMapClick.bind(this);
		this.is_navigating = false;
		this.is_breadcrumb_navigation = false;
		this.mobile_device = MOBILE_DEVICE;
		this.width;
		this.height;
		this.elapsedTime = 0;
		this.isTouch = 'ontouchstart' in document.documentElement;
		this.timestamp = performance.now() || Date.now();
		this.velocity = 0;
		this._velocity = 0;
		this.scrollDepth = 0;
		this.aspectRatio = ASPECT_RATIO;
		this.formatValue = formatValue;
		this.baseScale = window.innerWidth <= MOBILE_WIDTH ? 1 : 1;
		this.ratio;
		this.old_ratio = null;
		this.reverse = false;
		this.selectedCountry;
		this.queue = [];
		this.step = 0;
		this.app;
		this.container;
		this._container;
		this.tiles = [];
		this.projection;
		this.fps_threshold = 30;

		jQuery(document).ready(() => {
			document
				.querySelector(this.selector)
				.replaceChildren(
					new DOMParser().parseFromString(
						`<div class="ui indeterminate active text loader"></div>`,
						'text/html'
					).body.firstChild
				);
			d3.json(this.data_asset).then((data) => {
				this.data = data;
				this.initialize();
				Promise.resolve(this.render()).then(() => {
					setTimeout(() => {
						this.listen();
					}, 200);
				});
			});
		});
	}

	initialize() {
		this.model = new Model(this.data.map_data);
	}

	render() {
		document
			.querySelector(this.selector)
			.replaceChildren(
				new DOMParser().parseFromString(
					this.template(this),
					'text/html'
				).body.firstChild
			);
		this.initSelectors();
		this.initPIXI();
		this.bootstrap().then(() => {
			this.initMapView();
			//this.preloadImages();
		});
	}

	initSelectors() {
		this._labels = document.querySelector('#labels');
		this._labels1 = document.querySelector('#labels1');
		this._labels2 = document.querySelector('#labels2');
		this.legend = document.querySelector('#legend');
		this.sections = document.querySelector('#sections');
		this.tooltip = document.querySelector('#tooltip .tooltip');
		this.imagePane = document.querySelector('#pane');
		this.tooltipContainer = document.querySelector('#tooltip');
		this.breadcrumbs = document.querySelectorAll(
			'#breadcrumbs .breadcrumb'
		);
		this.map_selector = document.querySelector('#map');
		this.axes = document.querySelector('#axes');
		this.graphic = document.querySelector('#graphic');
		this.scale = document.querySelector('#scale');
		this.dropdown = jQuery('.ui.selection.search.dropdown');
		this.buttons = document.querySelector('#js-restrictions-corrected .buttons');
		this.dropdown_text = this.dropdown.children('.text')[0];
		this.dropdown_icon = this.dropdown.find('i')[0];
	}
	bootstrap() {
		return Promise.resolve()
			.then(this.destroy())
			.then(this.renderMap())
			.then(this.initLayout());
	}

	initPIXI() {
		this.width = getWidth();
		this.height = getHeight();
		RENDER_OPTIONS.width = this.width;
		RENDER_OPTIONS.height = this.height;
		this.app = new PIXI.Application(RENDER_OPTIONS);
		this.isWebGL = this.app.renderer.type == 1 ? true : false;
		this.fpsDelta = this.isWebGL ? 60 / 60 : 60 / 15;
		this.map_selector.appendChild(this.app.renderer.view);
		this.canvas = document.querySelector('#map canvas');
		this.resize();
		this.no_alias = isGPUBlacklisted() || NO_ALIAS;
		this._ticker = new PIXI.Ticker().add(this.ticker);
		this._pixi_init = true;
	}

	initLayout() {
		return new Promise((resolve, reject) => {
			this.layoutManager = new LayoutManager(
				this.container.children.concat([]),
				this._container,
				this.model,
				this.width,
				this.height,
				this._labels,
				this
			);
			this.selectedCountry = undefined;
			resolve(this.layoutManager.create('shi', 25));
		});
	}

	initMapView() {
		this.layoutManager.layout('map');
		this._center = this.layoutManager._center = this.center();
		this.zoomLevel = this.layoutManager.zoomLevel = 1;
	}

	preloadImages() {
		let images = [
			'usa',
			'russia',
			'bangladesh',
			'germany',
			'italy',
			'thailand',
		];
		for (let i = 0; i < images.length; i++) {
			let image = new Image(420, 240);
			image.src = `${ASSETS}img/compressed/${images[i]}.jpg`;
		}
	}

	destroy() {
		if (typeof this.country != 'undefined') {
			this.country.destroy();
			this.country = undefined;
		}
		if (typeof this.container != 'undefined') {
			this.container.destroy();
			this.container = undefined;
		}
		if (typeof this.boundaries != 'undefined') {
			this.boundaries.destroy();
			this.boundaries = undefined;
		}
		if (typeof this._container != 'undefined') {
			this._container.destroy();
			this._continer = undefined;
		}
		if (typeof this.spares_container != 'undefined') {
			this.spares_container.destroy();
			this.spares_container = undefined;
		}
		if (typeof this.spare != 'undefined') {
			this.spare.destroy();
			this.spare = undefined;
		}
		if (typeof this.spare_container != 'undefined') {
			this.spare_container.destroy();
			this.spare_container = undefined;
		}
		if (typeof this.scatter != 'undefined') {
			this.scatter.destroy();
			this.scatter = undefined;
		}
		if (typeof this.scatter_container != 'undefined') {
			this.scatter_container.destroy();
			this.scatter_container = undefined;
		}

		if (typeof this.layoutManager != 'undefined')
			this.layoutManager.abort();
		delete this.layoutManager;
		this.layoutManager = undefined;
		if (typeof this.spareManager != 'undefined') this.spareManager.abort();
		delete this.spareManager;
		this.spareManager = undefined;
		if (typeof this.scatterManager != 'undefined')
			this.scatterManager.abort();
		delete this.scatterManager;
		this.scatterManager = undefined;
		this._labels1.innerHTML = '';
		this.axes.innerHTML = '';
	}

	listen() {
		window.addEventListener('step', (e) => this.change(e));
		jQuery(document).ready(() => {
			const _resize = _.debounce(this.resize.bind(this), 450);
			window.addEventListener('resize', _resize);
			jQuery(window).scrollTop(0);
		});
		this.dropdown.dropdown({
			onChange: (value, text, $choice) =>
				this.handleDropdown(value, text, $choice),
			clearable: true,
		});
		jQuery(this.dropdown_icon).on('click', (e) =>
			this.handleDropdown('', undefined, undefined)
		);
		this.buttons.addEventListener('mousedown', (e) => {
			if (e.target.matches('.year')) this.handleYear(e);
			if (e.target.matches('.trend')) this.handleTrend(e);
		});
		this.visibility = jQuery('section.step').visibility({
			once: false,
			observeChanges: true,
			initialCheck: true,
			checkOnRefresh: true,
			refreshOnResize: false,
			continuous: true,
			onTopVisible: function (e) {
				var event = new CustomEvent('step', {
					detail: {
						id: parseInt(this.dataset.step),
						zoom: this.dataset.zoom,
						layout:
							typeof this.dataset.layout == 'undefined'
								? 'map'
								: this.dataset.layout,
						slice:
							typeof this.dataset.slice == 'undefined'
								? Infinity
								: parseInt(this.dataset.slice),
						center: this.dataset.center,
						offset_x:
							typeof this.dataset.x == 'undefined'
								? 0
								: parseInt(this.dataset.x),
						offset_y:
							typeof this.dataset.y == 'undefined'
								? 0
								: parseInt(this.dataset.y),
						min_year: this.dataset.min_year,
						max_year: this.dataset.max_year,
						order: this.dataset.order,
						reposition:
							typeof this.dataset.reposition == 'undefined'
								? 0
								: !!parseInt(this.dataset.reposition),
						image: this.dataset.image,
						caption: !!parseInt(this.dataset.caption)
							? this.innerHTML
							: ``,
						anchor: this.dataset.anchor,
					},
				});
				window.dispatchEvent(event);
			},
		});

		this._ticker.start();
		window.onbeforeunload = () => {
			this.app.stage.renderable = false;
			document.querySelector(this.selector).replaceChildren();
			window.scrollTo(0, 0);
		};
		window.onorientationchange = () => {
			this.map_selector.classList.remove('orient');
			this.legend.classList.remove('orient');
			setTimeout(() => {
				this.map_selector.classList.add('orient');
				this.legend.classList.add('orient');
			}, 1);
		};
	}

	renderDropdown() {
		return `<div class="ui fluid search selection dropdown">
					<div class="default text">Search for a country</div>
					<i class="dropdown icon" style="float:right;"></i>
					<div class="menu">${Object.entries(this.data.map_data)
						.sort((a, b) => a[1].name.localeCompare(b[1].name))
						.map((d) => this.dropdownItem(d[0]))
						.join('')}</div>
				</div>
			`;
	}

	dropdownItem(d) {
		return `<div class="${d == '408' ? 'disabled' : ''} item" data-value="${d}">${this.data.map_data[d].name}</div>`;
	}

	setBreadcrumb() {
		for (let i = 0; i < this.breadcrumbs.length; i++)
			this.breadcrumbs[i].classList.remove('active');
		document
			.querySelector(`[data-target="${this.anchor}"]`)
			.classList.add('active');
	}
	labelsOn() {
		this._labels.classList.remove('off');
		this._labels.classList.add('active');
	}
	labelsOff() {
		this._labels.classList.add('off');
		this._labels.classList.remove('active');
	}
	tooltipOff() {
		this.tooltipContainer.classList.remove('active');
	}
	legendOn() {
		this.legend.classList.add('active');
	}
	legendOff() {
		this.legend.classList.remove('active');
	}

	scaleOn() {
		this.scale.classList.add('active');
	}
	scaleOff() {
		this.scale.classList.remove('active');
	}

	center() {
		return [this.canvas.width / (2 * DPR), this.canvas.height / (2 * DPR)];
	}
}
window.restrictions = new Restrictions();
